var map = {
	"./action-plan.svg": 360,
	"./activity.svg": 361,
	"./audiolog.svg": 362,
	"./btsa.svg": 363,
	"./diary.svg": 364,
	"./exam.svg": 365,
	"./form.svg": 366,
	"./forum.svg": 367,
	"./interactive.svg": 368,
	"./multiplechoice.svg": 369,
	"./original-exercise.svg": 370,
	"./podcast.svg": 371,
	"./poll.svg": 372,
	"./reading.svg": 373,
	"./video.svg": 374,
	"./webinar.svg": 375
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 160;